import { render, staticRenderFns } from "./CorporateSideMenu.vue?vue&type=template&id=1c1016d8&scoped=true&"
import script from "./CorporateSideMenu.vue?vue&type=script&lang=js&"
export * from "./CorporateSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./CorporateSideMenu.vue?vue&type=style&index=0&id=1c1016d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1016d8",
  null
  
)

export default component.exports